<template>
    <v-btn
        :disabled="isDisabled || isLoading"
        :loading="isLoading"
        :text="isText"
        :color="btnColor"
        :outlined="isOutlined"
        :right="isRight"
        class="text-caption"
        :style="style"
        @click="$emit('click')"
        @mouseenter="$emit('mouseenter', $event)"
        @mouseleave="$emit('mouseleave', $event)"
    >
        <v-icon v-if="!!btnIcon && !!labelText" :small="small" class="mr-2">
            {{ btnIcon }}
        </v-icon>
        <v-icon v-else-if="!!btnIcon" :small="small">
            {{ btnIcon }}
        </v-icon>
        <span class="button-label">
            {{ labelText }}
        </span>
    </v-btn>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'ButtonAppControl',
})
export default class ButtonAppControl extends Vue {
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: undefined }) label: string;
    @Prop({ default: false }) small: boolean;
    @Prop({ default: '' }) icon: string;
    @Prop({ default: false }) text: boolean;
    @Prop({ default: false }) outlined: boolean;
    @Prop({ default: 'accent' }) color: string;
    @Prop({ default: false }) right: boolean;

    // IE11暫定対応
    // ダイアログ上のv-btnをローディング状態にすると何かがはみ出でているように思われるので
    // それがレイアウトに影響しないようにする
    style = {
        overflow: 'hidden',
    };

    get isDisabled(): boolean {
        return this.disabled;
    }
    get isLoading(): boolean {
        return this.loading;
    }
    get labelText(): string {
        return this.label;
    }
    get btnIcon(): string {
        return this.icon;
    }
    get isText(): boolean {
        return this.text;
    }
    get isRight(): boolean {
        return this.right;
    }
    get btnColor(): string {
        return this.color;
    }
    get isOutlined(): boolean {
        return this.outlined;
    }
}
</script>

<style lang="scss" scoped>
.button-label {
    font-weight: bolder;
}
</style>
